import styled from 'styled-components';

export const SelectedGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const SelectedSign = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 6px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background: #fafafa;
  cursor: ${({ as }) => (as === 'button' ? 'pointer' : 'default')};

  img {
    width: 40px;
    height: 40px;
    object-fit: contain;
  }
`;

export const SelectedCode = styled.span`
  font-size: 10px;
  color: #666;
`;

export const RemoveButton = styled.button`
  position: absolute;
  top: -6px;
  right: -6px;
  width: 18px;
  height: 18px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: #999;
  color: #fff;
  font-size: 12px;
  line-height: 18px;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.antd?.colorPrimary || '#1677ff'};
  }
`;

export const AddSignButton = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: #999;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.antd?.colorPrimary || '#1677ff'};
  }
`;

export const EmptyHint = styled.p`
  margin: 0;
  color: #999;
  font-size: 13px;
`;
